import { Modal, Row, Col, Table, FloatButton, Spin } from "antd";
import { useRef, useState } from "react";
import dayjs from "dayjs";

const ListExportInvestigate = ({ open, close, data }) => {
  const [loading, setLoading] = useState(false);
  const scrollRef = useRef(null);

  const handleCancel = () => {
    console.log("Clicked cancel button");
    close(false);
  };
  console.log(data);

  const columns = [
    {
      title: "ลำดับ",
      key: "index",
      align: "center",
      width: 20,
      render: (_, __, index) => index + 1,
    },
    {
      title: "เลขสัญญา",
      dataIndex: "contno",
      key: "contno",
      align: "center",

      render: (text, record) => <>{record.contno}</>,
    },
    {
      title: "ชื่อ-นามสกุล",
      dataIndex: "dateRound",
      key: "dateRound",
      align: "center",

      render: (text, record) => (
        <>
          {record.SNAM} {record.NAME1} {record.NAME2}
        </>
      ),
    },
    {
      title: "สถานะ",
      dataIndex: "dateRound",
      key: "dateRound",
      align: "center",

      render: (text, record) => (
        <>{record.garno === 0 ? "ผู้เช่าซื้อ" : `ผู้ค้ำที่ ${record.garno}`}</>
      ),
    },
    {
      title: "วันที่ร้องขอสืบ",
      dataIndex: "dateRound",
      key: "dateRound",
      align: "center",

      render: (text, record) => (
        <>{dayjs(record.dateRound).add(543, "year").format("DD MMM YY")}</>
      ),
    },
    {
      title: "วันที่อนุมัติสืบ",
      dataIndex: "dateSend",
      key: "dateSend",
      align: "center",

      render: (text, record) => (
        <>{dayjs(record.dateSend).add(543, "year").format("DD MMM YY")}</>
      ),
    },
  ];

  const TableData = () => {
    return (
      <div
        ref={scrollRef}
        style={{
          maxHeight: 800, // กำหนดความสูงให้เกิดสกอร์ล
          overflow: "auto",
          position: "relative", // ให้ float วางอิงกล่องนี้ได้
        }}
      >
        <Row>
          <Col span={24}>
            <Table
              size="large"
              rowKey={(r) => r.key}
              columns={columns}
              dataSource={data}
              pagination={false}
              bordered
              style={{ marginTop: 16 }}
              footer={() => (
                <div
                  style={{
                    textAlign: "right",
                    fontWeight: 600,
                    fontSize: 16,
                  }}
                >
                  จำนวนทั้งหมด {data.length}
                </div>
              )}
            />
            <FloatButton.BackTop />
          </Col>
        </Row>
        <FloatButton.BackTop
          target={() => scrollRef.current} // ฟังสกอร์ลจากกล่องนี้
          visibilityHeight={80} // โผล่เมื่อเลื่อนเกิน 80px
          style={{ right: 16, bottom: 16 }}
        />
      </div>
    );
  };

  return (
    <Spin spinning={loading} size="large" tip=" Loading... ">
      <Modal
        title={
          <span style={{ fontSize: 16, fontWeight: 400, color: "#333" }}>
            รายการสืบทรัพย์
          </span>
        }
        open={open}
        onCancel={handleCancel}
        width={850}
        footer={null}
        keyboard={true}
        centered
        styles={{
          body: { padding: "24px 32px" }, // ใช้แทน styles.body
        }}
      >
        {TableData()}
      </Modal>
    </Spin>
  );
};
export default ListExportInvestigate;
